export enum DiscountType {
  event = "イベント",
  discount = "割引",
}
